export default "__VITE_ASSET__C5MkS8XX__"